import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { handleExport } from '../../../../helpers/export'
import Service from '../../core/service'

export const getPortfolioOverview = createAsyncThunk(
  'portfolio/summary/getPortfolioOverview',
  async (params, { rejectWithValue }) => {
    try {
      const response = await Service.getPortfolioOverview(params)
      if (response.success) return response.data
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const exportPortfolioOverview = createAsyncThunk(
  'portfolio/summary/exportPortfolioOverview',
  async (params, { rejectWithValue }) => {
    try {
      const response = await Service.exportPortfolioOverview(params)
      handleExport(response.data, response.filename)
    } catch (error) {
      return rejectWithValue({ loading: false })
    }
  },
)
